//Built-in libraries

//Third party libraries

//Custom components

//Services

//STP Libraries

//Assets and Miscellaneous
import { CurrencyFormatDisplay } from '@/components/UI/NumberFormatDisplay/CurrencyFormatDisplay';

//Component Begin

export interface IProjectBudgetProps {
  step2: any;
}
export default function ProjectBudget({ step2 }: IProjectBudgetProps) {
  const { estimatedProjectBudget } = step2;

  const totalStateGrants = estimatedProjectBudget.reduce((partialSum: any, budget: any) => partialSum + budget.stateGrant, 0);
  const totalOtherFunds = estimatedProjectBudget.reduce((partialSum: any, budget: any) => partialSum + budget.otherFunds, 0);
  const totalBudget = estimatedProjectBudget.reduce((partialSum: any, budget: any) => partialSum + budget.totalFunds, 0);

  return (
    <section aria-labelledby='applicant-information-title'>
      <div className='bg-white shadow sm:rounded-lg'>
        <div className='py-5'>
          <div className='px-4 py-2 sm:px-6 border-l-4 border-primaryColor-normal'>
            <h2 id='applicant-information-title' className='m-0 text-lg leading-6 font-medium text-primaryColor-normal'>
              Project Budget
            </h2>
          </div>
        </div>
        <div className='border-t border-gray-200 px-4 py-5 sm:px-6'>
          <h3 className='py-5'>Total Estimated Project Budget</h3>
          <div className='space-y-2 w-full h-full ring-1 ring-neutralColor-lighter overflow-x-scroll mb-8'>
            <table className='divide-y divide-gray-200 w-full'>
              <thead className='bg-gray-100'>
                <tr className='flex justify-between px-5 py-4'>
                  <th className='flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-32'>Item</th>
                  <th className='flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40'>State Funds ($)</th>
                  <th className='flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-40'>Other Funds ($)</th>
                  <th className='flex py-2 font-bold tracking-wider text-neutralColor-normal text-left text-xs w-32'>Total Funds ($)</th>
                </tr>
              </thead>
              <tbody className='bg-white divide-y divide-gray-200'>
                {estimatedProjectBudget?.map((project: any) => (
                  <tr key={project.id} className='flex items-center w-full justify-between px-5 py-2'>
                    <td className='w-32 flex items-start capitalize'>{project?.item}</td>

                    <td className='w-40 flex items-start capitalize'>
                      <CurrencyFormatDisplay value={project?.stateGrant ?? 0} />
                    </td>
                    <td className='w-40 flex items-start capitalize'>
                      <CurrencyFormatDisplay value={project.otherFunds ?? 0} />
                    </td>
                    <td className='w-40 flex items-start capitalize'>
                      <CurrencyFormatDisplay value={project?.totalFunds ?? 0} />
                    </td>
                  </tr>
                ))}
                <tr className='flex items-center w-full justify-between px-5 py-2'>
                  <td className='w-32 font-bold'>Total</td>
                  <td className='w-40 font-bold'>
                    <CurrencyFormatDisplay value={totalStateGrants ?? 0} />
                  </td>
                  <td className='w-40 font-bold'>
                    <CurrencyFormatDisplay value={totalOtherFunds ?? 0} />
                  </td>
                  <td className='w-40 font-bold'>
                    <CurrencyFormatDisplay value={totalBudget ?? 0} />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <dl className='grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 mb-8'>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Is the construction contract at least $250,000 and will State funds be used to pay for 25% or more of the contract ?
              </dt>
              <dd className='mt-1 text-sm text-gray-900 capitalize'>{step2?.q1}</dd>
            </div>
            <div className='sm:col-span-2'>
              <dt className='text-sm font-medium text-gray-500'>
                Have you received $1,000,000 or more and is the construction contract $500,000 or more ?
              </dt>
              <dd className='mt-1 text-sm text-gray-900 capitalize'>{step2?.q2}</dd>
            </div>
          </dl>
        </div>
      </div>
    </section>
  );
}
